module.exports = __webpack_public_path__ + "static/media/name-games.65b4c3c2.png";